import registry from "../../content/registry/experience-v2.json";

export type ExperienceV2Link = {
  label: string;
  href: string;
};

export type ExperienceV2Detail = {
  heading: string;
  items: string[];
};

export type ExperienceV2RoleType = "employment" | "parallel-independent";

export type ExperienceV2Role = {
  id: string;
  organisation: string;
  employerGroupId?: string;
  dateRange: string;
  roleType?: ExperienceV2RoleType;
  parallelWorkLabel?: string;
  officialTitle: string;
  scope: string;
  evidence: string[];
  seniorityNote?: string;
  additionalDetail?: ExperienceV2Detail[];
  claimIds: string[];
};

export type ExperienceV2EmployerGroup = {
  id: string;
  organisation: string;
  dateRange: string;
  roleIds: string[];
};

export type ExperienceV2Education = {
  institution: string;
  credential: string;
  summary: string;
  additionalDetail?: string;
  claimIds: string[];
};

export type ExperienceV2Page = {
  heading: string;
  positioning: string;
  availabilityNote: string;
  caseStudiesLink: ExperienceV2Link;
};

export type ExperienceV2CaseStudiesHandOff = {
  heading: string;
  link: ExperienceV2Link;
  selectedCaseStudyIds: string[];
};

export type ExperienceV2Registry = {
  schemaVersion: string;
  page: ExperienceV2Page;
  strengths: string[];
  employerGroups: ExperienceV2EmployerGroup[];
  timeline: ExperienceV2Role[];
  education: ExperienceV2Education;
  caseStudiesHandOff: ExperienceV2CaseStudiesHandOff;
};

export const experienceV2 = registry as ExperienceV2Registry;
